import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// 数据库管理基础URL
const baseDBUrl = config.baseDBUrl
const dbBaseUrl = baseDBUrl + '/database/api/v1/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getInstanceList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/instance/',
    headers: baseHeaders,
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const getProcessList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/processlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceUserList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/userlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const deleteInstance = (id) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/instance/' + id + '/',
    method: 'delete'
  })
}

export const pushInstance = (data, id) => {
  let url = dbBaseUrl + 'mongodb/instance/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const resetUserPassword = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/password/reset/',
    data: data,
    method: 'POST'
  })
}

export const deleteInstanceUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/user/remove/',
    data: data,
    method: 'POST'
  })
}

export const getPrivList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/privilege/',
    data: data,
    method: 'POST'
  })
}

export const updatePrivilege = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/privilege/update/',
    data: data,
    method: 'POST'
  })
}

export const showDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/database/show/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/database/list/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const removeDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/database/remove/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getParamList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/current/parameter/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const setParam = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/current/parameter/set/',
    data: data,
    method: 'POST'
  })
}

export const getInstanceLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/server/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getOpsLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/instancelog/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const createUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/user/create/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getRoleNameList = () => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/rolename/',
    headers: baseHeaders,
    method: 'get'
  })
}

export const getInstanceStats = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/stats/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceNode = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/nodeList/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const setProfiler = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/profiler/set/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getInstanceProfile = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/profiler/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getAggregateProfile = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mongodb/profiler/aggregate/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}
